import invoicesAdmin from './invoices-admin'

export default [...invoicesAdmin]
